import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
export class CoralogixWebTracerProvider extends WebTracerProvider {
}
//# sourceMappingURL=CoralogixWebTracerProvider.js.map